import { TuitionFeeFilterValue } from "@studyportals/search-api-interface";

export const tuitionFeeLabels: Record<string, string> = {
	[TuitionFeeFilterValue.ZERO_TO_TWO_THOUSAND_FIVE_HUNDRED]: 'Affordable'
};

export const getTuitionFeeChipLabel = (valueId: string): string => {
	if (tuitionFeeLabels[valueId]) {
		return tuitionFeeLabels[valueId];
	}

	try {
		const [min, max] = JSON.parse(valueId) as [number, number];
		if (min > 0 && max !== -1) return 'Tuition Fee Range';

		if (min > 0) return 'Min Tuition Fee';

		if (max !== -1) return 'Max Tuition Fee';
	} catch {
		return 'Tuition Fee';
	}
	return '';
};
